var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-row-center-start item-height bg-F8F8F8 boderra8"},_vm._l((_vm.titlelist),function(v,i){return _c('div',{key:i,staticClass:"item-height flex-row-center-center",style:({'flex': v.flex,})},[_c('div',{staticClass:"fz-16 co-999999"},[_vm._v(_vm._s(v.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }